import { useNavigate } from 'react-router-dom';
import { Row, Col, GRID } from '../components/custom';

import { AssignmentReturnedOutlined, CheckCircleOutlineRounded, InsightsRounded } from '@mui/icons-material';

import firstImage from '../images/landing/one.webp';
import secondImage from '../images/landing/two.webp';
import thirdImage from '../images/landing/three.webp';

export default function Landing()
{
    const navigate = useNavigate();

    return (
        <Col id='landing'>
            <Col className='banner'>
                <span className='title'>From listening to action — uncover what matters, and why</span>
                <span className='desc'>We help organizations decode what their employees and customers are really saying — and what to do about it. Our consulting services combine advanced statistical analytics, sentiment intelligence, and external market signals to transform feedback into strategic insight.</span>
            </Col>
            <Row className='big'>
                <img src={firstImage} alt='firstImage'/>
                <Col className='content'>
                    <span className='title'>Employee Experience Intelligence</span>
                    <span className='descsmall'>Capture employee voice across the full journey — from onboarding to exit. Combine structured feedback with open-text responses to reveal how your workforce truly feels.</span>
                    <button onClick={() => navigate('/solutions/employee-experience')}>Learn More</button>
                </Col>
            </Row>
            <Row className='big'>
                <Col className='content'>
                    <span className='title'>Customer Experience Intelligence</span>
                    <span className='descsmall'>The <strong> Customer Experience Intelligence Suite </strong> empowers you to capture feedback at every stage of the customer journey, uncover what's driving loyalty or churn, and turn insights into actions that improve satisfaction, retention, and revenue.</span>
                    <button onClick={() => navigate('/solutions/customer-experience')}>Learn More</button>
                </Col>
                <img src={secondImage} alt='secondImage'/>
            </Row>
            <Row className='big'>
                <img src={thirdImage} alt='thirdImage'/>
                <Col className='content'>
                    <span className='title'>Secondary Research Intelligence</span>
                    <span className='descsmall'>Even the best survey data needs external context to drive decisions. Our Secondary Research capability enhances your EX and CX programs with curated insights from industry trends, global trends, and best practices.</span>
                    <button onClick={() => navigate('/solutions/secondary-research')}>Learn More</button>
                </Col>
            </Row>
            <Col className='small'>
                <span className='title extra'>Unmet Needs in Survey Analytics</span>
                <span className='descsmall'>Identifying what matters most is often missing or oversimplified.</span>
                <GRID className='table1'>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Causal Analysis, Not Correlation</span>
                    </Row>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Driver or Impact Analysis</span>
                    </Row>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Longitudinal & Cohort Analytics</span>
                    </Row>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Unstructured Text Analysis</span>
                    </Row>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Segmented & Comparative Insights</span>
                    </Row>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Narrative and Storytelling</span>
                    </Row>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Statistical Validity Indicators</span>
                    </Row>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Closed-loop analytics</span>
                    </Row>
                    <Row>
                        <AssignmentReturnedOutlined/>
                        <span className='descsmall'>Follow-Through Insights</span>
                    </Row>
                </GRID>
            </Col>
            <Col className='small'>
                <span className='title'>Insights That Drive Meaningful Change</span>
                <GRID className='table2'>
                    <Col>
                        <Row>
                            <InsightsRounded/>
                            <span className='desc'>End-to-End Survey Analytics Expertise</span>
                        </Row>
                        <span className='descsmall'>We interpret the data, apply rigorous analysis, and translate findings into business-ready recommendations.</span>
                    </Col>
                    <Col>
                        <Row>
                            <InsightsRounded/>
                            <span className='desc'>Customized Insight Frameworks</span>
                        </Row>
                        <span className='descsmall'>No cookie-cutter reports. From journey-stage segmentation to persona-based reporting, every output is fit-for-purpose.</span>
                    </Col>
                    <Col>
                        <Row>
                            <InsightsRounded/>
                            <span className='desc'>Action Planning Support Services</span>
                        </Row>
                        <span className='descsmall'>We go beyond reporting. We help identify root causes, recommend interventions, and  implementation roadmaps.</span>
                    </Col>
                    <Col>
                        <Row>
                            <InsightsRounded/>
                            <span className='desc'>External Insight Integration</span>
                        </Row>
                        <span className='descsmall'>We augment internal survey results with curated public signals (e.g., Glassdoor, Indeed,  and thematic research to bring depth and market perspective.</span>
                    </Col>
                    <Col>
                        <Row>
                            <InsightsRounded/>
                            <span className='desc'>Cross - Functional Expertise</span>
                        </Row>
                        <span className='descsmall'>We bring experience across HR, CX, data science, and behavioral research — offering a more holistic interpretation of feedback and sentiment.</span>
                    </Col>
                    <Col>
                        <Row>
                            <InsightsRounded/>
                            <span className='desc'>Rapid, Flexible Delivery Models</span>
                        </Row>
                        <span className='descsmall'>Choose from one-time deep-dive studies, quarterly pulses, or embedded analyst models — we adapt to your cadence, not the other way around.</span>
                    </Col>
                </GRID>
            </Col>
            <Col className='small'>
                <span className='title'>Why Choose Us</span>
                <GRID className='table3'>
                    <Row>
                        <CheckCircleOutlineRounded/>
                        <span className='descsmall'>We Make Survey Data Actionable</span>
                    </Row>
                    <Row>
                        <CheckCircleOutlineRounded/>
                        <span className='descsmall'>We Work With What You Have</span>
                    </Row>
                    <Row>
                        <CheckCircleOutlineRounded/>
                        <span className='descsmall'>Rapid, Flexible Delivery Models</span>
                    </Row>
                    <Row>
                        <CheckCircleOutlineRounded/>
                        <span className='descsmall'>We Turn Open Text into Strategic Actionable Signals</span>
                    </Row>
                    <Row>
                        <CheckCircleOutlineRounded/>
                        <span className='descsmall'>We Tailor Insights & recommendations to Your Context</span>
                    </Row>
                    <Row>
                        <CheckCircleOutlineRounded/>
                        <span className='descsmall'>We Add External Perspective That You Can Trust</span>
                    </Row>
                </GRID>
            </Col>
        </Col>
    )
}